// src/slices/weather/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getWeather = createAsyncThunk("weather/getWeather", async (payload, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/weather`, { params: { city: payload?.city, page: payload?.page, limit: payload?.limit } });

    return response.data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
